import {SelectItem} from '@cypro/ui/components/form/select'
import {Location, Section, UserAccessLocation, Ward} from '@cypro/engine/schema'

interface GroupedAccessLocation extends Location {
  sections: (Section & {wards: Ward[]})[]
}

export function groupAccessLocations(accesses: readonly UserAccessLocation[]): GroupedAccessLocation[] {
  const locationsMap = new Map<string, GroupedAccessLocation>()

  for (const access of accesses) {
    const {location, section, ward} = access

    if (!location) continue

    let loc = locationsMap.get(location.id)
    if (!loc) {
      loc = {...location, sections: []}
      locationsMap.set(location.id, loc)
    }

    if (section) {
      let sec = loc.sections.find(s => s.id === section.id)
      if (!sec) {
        sec = {...section, wards: []}
        loc.sections.push(sec)
      }

      if (ward && !sec.wards.some(w => w.id === ward.id)) {
        sec.wards.push(ward)
      }
    }
  }

  return Array.from(locationsMap.values())
}

export function mapLocationsToSelectItems(locations: Location[]): SelectItem[] {
  return locations.map(location => ({...location, label: `${location.code} - ${location.name}`, value: location.id}))
}
